import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { Prop } from 'vue-property-decorator';
import { LocalStorageService } from '@/services/local-storage.service';
import { APP_EVENT_BUS, APP_STORAGE_KEYS } from '@/core/enums/app.enum';

@Component({
  name: 'ed-language'
})
export default class EdLanguage extends Vue {

  @Prop() menuClass: string;
  
  /* Computed */
  get language(): string {
    return KEYS.LANGUAGES_LABEL[this.$i18n.locale.toUpperCase()];
  }

  get menu() {
    return [{
      id: 0,
      text: String(this.$i18n.t('language.english')),
      type: KEYS.LANGUAGES.EN
    },
    {
      id: 1,
      text: String(this.$i18n.t('language.spanish')),
      type: KEYS.LANGUAGES.ES
    }];
  }

  goToOption(item: any) {
    LocalStorageService.setItem(APP_STORAGE_KEYS.ED_LANGUAGE_SELECTED, item.type);
    this.$i18n.locale = item.type;
    this.$edEventBus.$emit(APP_EVENT_BUS.LANGUAGE_CHANGED, item.type);
  }

}